export const GET_PRODUCT_CATALOGUE = 'GET_PRODUCT_CATALOGUE';
export const GET_PRODUCT_CATALOGUE_SUCCESS = 'GET_PRODUCT_CATALOGUE_SUCCESS';
export const GET_PRODUCT_CATALOGUE_FAILED = 'GET_PRODUCT_CATALOGUE_FAILED';